import React, { useState, useEffect } from "react";
import PrimaryButton from "../../elements/primary-button";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import RangeOptionSelect from "../../elements/range-option-select";
import PropTypes from "prop-types";
import Slider from "../pdp-refine-plan/components/Slider";
import CashOptions from "../pdp-refine-plan/components/CashOptions";
import "./style.scss";
import InfoModal from "../../components/InfoModal";
import PdpSummary from "../../react-components/pdp-summary";
import InfoIcon from "../../svg-icons/info";
import api from "../../utils/api";
import { MathUtils } from "../../utils";
import { ProductType, financingTab } from "../../utils/lynkco-constants";
import { useSelector } from "react-redux";
import { pdpSummarySelector } from "../../selectors/pdp";
import PdpOption from "../../react-components/pdp-option";

/* Realized too late that 'Refine plan' and 'Choose financing' were supposed to be different pages, hence the somewhat messy code.
   This component is meant to be usable for both. */
import LoadingSpinner from "../../elements/loading-spinner";
import { setDisclaimer } from "../../services/pdpSummaryService";
/* Realized too late that 'Refine plan' and 'Choose financing' were supposed to be different pages, hence the somewhat messy code.
      This component is meant to be usable for both. */
let CurrentLab = null;
const Pdpfinancing = ({ heading, tabs, labels, info, vehicleProps, loanDisclaimer, cashOptions, checkoutButton, onCheckout, onOptionSelected, onTabSelected, lang, loanSummary, cashSummary, summarySections, changeValueCallback }) => {
  const pdpSummary = useSelector(pdpSummarySelector);
  /* State is stored as an array of tabs with arrays of states. */
  const [plan, setPlan] = useState(null);
  const [sliders, setSliders] = useState([]);
  const [loanFeatures, setLoanFeatures] = useState([]);
  const [summaryFeatures, setSummaryFeatures] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [currentTab, setCurrentTab] = useState(() => {
    return tabs ? tabs.options.filter(x => x.value === tabs.defaultOption.value)[0] : null;
  });
  const [lastSummaryProps, setLastSummaryProps] = useState(() => {
    return currentTab.id === financingTab.LOAN ? loanSummary : cashSummary;
  });
  const [monthlyPrice, setMonthlyPrice] = useState(0);
  const [effectiveInterest, setEffectiveInterest] = useState(null);
  const [cashPreviewRes, setCashPreviewRes] = useState();
  const [loanProductList, setLoanProductList] = useState([]);
  const [loanProduct, setLoanProduct] = useState(null);
  const [SECCI, setSECCI] = useState(null);
  const [currentSimulationId, setCurrentSimulationId] = useState(null);
  const [downPayment, setDownPayment] = useState(null);
  const [finalPayment, setFinalPayment] = useState(null);
  const [rate, setRate] = useState(null);
  const [period, setPeriod] = useState(null);
  const [orderSummarySections, setOrderSummarySections] = useState([]);
  const [loanLoading, setLoanLoading] = useState(false);
  const [loanErrorMessage, setLoanErrorMessage] = useState(null);
  const [loanProductLoading, setLoanProductLoading] = useState(() => {
    return currentTab.id === financingTab.LOAN;
  });
  const openInfoModal = content => {
    // setModalContent(content);
    setShowInfoModal(true);
  };
  const country = lang.indexOf("-") > -1 ? lang.split("-")[1] : null;
  const updatePlan = (tab, index, value, val) => {
    let newPlan = [...plan];
    if (val) {
      val.value = value === true || value === false ? val.value : value;
      val.price = value === true || value === false ? 0 : value;
      value = val;
    }

    newPlan[tab][index] = value;
    setPlan(newPlan);
    onOptionSelected && onOptionSelected(newPlan, tab);
    onCheckout(plan, tab, "");
  };
  CurrentLab = currentTab.id;
  let disclaimerText = loanDisclaimer;
  let loanProducts = [],
    currentProduct = null,
    currentDownPayment = null,
    currentPeriod = null,
    currentFinalPayment = null,
    currentRate = null;
  let defaultDownPayment = null,
    defaultFinalPayment = null;
  let cashFeatures = [];

  useEffect(() => {
    const tab1 = sliders.map(slider => {
      /* Slider can be either a toggle or a range slider */
      return slider.selected ? slider.selected : slider.value;
    });
    /* Maybe not super elegant to always have the cash options included even when not used, but it works */
    const tab2 =
      cashOptions && cashOptions.checkboxes
        ? cashOptions.checkboxes.map(box => {
            return box.selected;
          })
        : [];

    let disclaimerText = loanDisclaimer;
    if (tabs && currentTab && currentTab.value != tabs.defaultOption.value && cashOptions) {
      disclaimerText = cashOptions.disclaimer;
    }
    setPlan([tab1, tab2]);

    // getLoanProducts();
  }, []);

  useEffect(() => {
    setSummaryFeaturesPrice();
  }, [pdpSummary, lastSummaryProps]);

  useEffect(() => {
    if (currentTab.id === financingTab.LOAN) {
      getLoanProducts();
    }
  }, [vehicleProps.retailPrice, vehicleProps.engine]);
  const getCashPrice = async () => {
    const { obj } = await api.vehicle.order.preview(null, {
      productType: ProductType.vehicle,
      ...pdpSummary?.apiBody
    });
    setCashPreviewRes(obj);
    return obj;
  };
  const setSummaryFeaturesPrice = async () => {
    const previewRes = await getCashPrice();
    const { orderExtraData, orderItems } = previewRes;
    const { wheelServiceDisclaimer, carePlanDisclaimer } = setDisclaimer(previewRes);
    let summaryFeatureFields = [];
    if (currentTab.id === financingTab.CASH) {
      let summaryFeatureFields1 = cashSummary.fields?.features?.map(item => {
        const { prefixOfValue, suffixOfValue, text, disclaimer, value } = item.fields;
        return {
          label: text.value,
          apiLabel: value?.fields?.phrase?.value,
          prefixOfValue: prefixOfValue.value,
          suffixOfValue: suffixOfValue.value,
          value: getLabelValue(item?.fields, orderExtraData, orderItems),
          disclaimer: disclaimer?.value
        };
      });
      let summaryFeatureFields2 = cashSummary.fields?.features2?.map(item => {
        const { prefixOfValue, suffixOfValue, text, disclaimer, value } = item.fields;
        let disclaimerValue = "";
        switch (value?.fields?.phrase?.value?.toLowerCase()) {
          case "servicepackage":
            disclaimerValue = carePlanDisclaimer;
            break;
          case "winterwheelservice":
            disclaimerValue = wheelServiceDisclaimer;
            break;
          default:
            break;
        }
        return {
          label: text.value,
          apiLabel: value?.fields?.phrase?.value,
          prefixOfValue: prefixOfValue.value,
          suffixOfValue: suffixOfValue.value,
          value: getLabelValue(item?.fields, orderExtraData, orderItems),
          disclaimer: disclaimerValue
        };
      });
      summaryFeatureFields = [summaryFeatureFields1, summaryFeatureFields2];
    } else {
      let summaryFeatureFields1 = loanSummary.fields?.features?.map(item => {
        const { prefixOfValue, suffixOfValue, text, disclaimer, value } = item.fields;
        return {
          label: text.value,
          apiLabel: value?.fields?.phrase?.value,
          prefixOfValue: prefixOfValue.value,
          suffixOfValue: suffixOfValue.value,
          value: getLabelValue(item?.fields, orderExtraData, orderItems),
          disclaimer: disclaimer?.value
        };
      });
      let summaryFeatureFields2 = loanSummary.fields?.features2?.map(item => {
        const { prefixOfValue, suffixOfValue, text, disclaimer, value } = item.fields;
        let disclaimerValue = "";
        switch (value?.fields?.phrase?.value?.toLowerCase()) {
          case "servicepackage":
            disclaimerValue = carePlanDisclaimer;
            break;
          case "winterwheelservice":
            disclaimerValue = wheelServiceDisclaimer;
            break;
          default:
            break;
        }
        return {
          label: text.value,
          apiLabel: value?.fields?.phrase?.value,
          prefixOfValue: prefixOfValue.value,
          suffixOfValue: suffixOfValue.value,
          value: getLabelValue(item?.fields, orderExtraData, orderItems),
          // value: `${prefixOfValue.value}${0}${suffixOfValue.value}`,
          disclaimer: disclaimerValue
        };
      });
      summaryFeatureFields = [summaryFeatureFields1, summaryFeatureFields2];
    }
    setOrderSummarySections(summaryFeatureFields);
  };
  const getLabelValue = (item, orderExtraData, orderItems) => {
    let price = 0;
    const labelValue = item?.value?.fields?.phrase?.value;
    switch (labelValue?.toLowerCase()) {
      case "modelprice":
        orderItems.forEach(order => {
          if (order?.productType === ProductType.vehicle) {
            price = order.paymentAmt;
          }
        });
        break;
      case "carprice":
        let carzprice = 0;
        orderItems.forEach(order => {
          if (order?.productType === ProductType.vehicle) {
            carzprice = order.paymentAmt;
          }
        });
        price = orderExtraData?.towbarFee + orderExtraData?.winterWheelsFee + carzprice;
        break;
      case "monthlyfree":
        price = orderExtraData?.wheelServiceFee + orderExtraData?.servicePackageFee;
        break;
      default:
        price = orderExtraData[labelValue];
        break;
    }
    return `${item?.prefixOfValue?.value}${MathUtils.priceFormat(price || 0, lang)}${item?.suffixOfValue?.value}`;
  };
  const tabClick = option => {
    onTabSelected && onTabSelected(option);
    setCurrentTab(option);
    CurrentLab = option.id;
    /* Measurement */
    let dataLayer = window.dataLayer || [];

    let chosen_financing = "";
    switch (option.id) {
      case "LOAN":
        chosen_financing = "LOAN";
        break;
      case "CASH":
        chosen_financing = "CASH";
        break;
    }
    dataLayer.push({
      event: "financeChosen",
      eventCategory: "finance",
      eventAction: "finance",
      eventLabel: chosen_financing
    });
    if (option.id === financingTab.LOAN) {
      setLastSummaryProps(loanSummary);
      getLoanProducts();
    } else {
      setSummaryFeatures([]);
      setLastSummaryProps(cashSummary);
    }
  };
  const joinSummeryLabelValue = (value, type) => {
    switch (type) {
      case "currency":
        return MathUtils.priceFormatSpecial(value, lang, currentTab.id === "LOAN");
      case "percentage":
        return MathUtils.percentFormat(value, lang);
      // case "[integer]":
      //   value = value;
      //   break;
      // case "[string]":
      //   value = value;
      //   break;
      default:
        return value;
    }
  };
  const setSummaryValues = () => {
    if ((currentPeriod || period) && !loanLoading) {
      setLoanLoading(true);
      api.calculation
        .multisimulation(null, {
          countryCode: country.toUpperCase(),
          quotes: [
            {
              productId: currentProduct?.productId || loanProduct?.productId,
              downPayment: currentDownPayment || downPayment,
              loanType: currentProduct?.loanType || loanProduct?.productId,
              finalPayment: currentFinalPayment || finalPayment,
              number: currentPeriod || period,
              retailPrice: vehicleProps.retailPrice,
              engine: vehicleProps.engine,
              model: vehicleProps.model,
              defaultRate: currentRate || rate
            }
          ]
        })
        .then(res => {
          if (res && res.status === 200 && CurrentLab === financingTab.LOAN) {
            if (res.data?.quotes?.length) {
              let currentQuote = res.data.quotes.filter(x => x.period?.number === currentPeriod)[0];
              let _loanFeatures = currentQuote?.summery.map(item => ({
                label: item.label?.local,
                value: joinSummeryLabelValue(item.label?.value, item?.type),
                id: item.name
              }));
              if (currentQuote) {
                let index = currentQuote.summery.findIndex(x => x.source === "$.quotes[0].paymentsSchedule.summaryPayments[?(@.typeInstalment === 'recurrentPayment')].payment");
                if (index !== -1) {
                  _loanFeatures[index].footnote = loanSummary?.fields?.footNoteSymbol?.value;
                }
                setSECCI(currentQuote.auto?.documentation?.SECCI);
                setCurrentSimulationId(currentQuote.simulationChecksum);
                let _effectiveInterest = currentQuote?.interestRates?.filter(x => x.typeInterestRate === "EffectiveInterest");
                // specail for IT
                let _summaryPriceTag = "";
                if (lang === "it-it") {
                  let data = currentQuote.summery.find(x => x.source === "$.quotes[0].interestRates[?(@.typeInterestRate === 'EffectiveInterest')].value");
                  if (data?.label?.local && data?.label?.value) {
                    _summaryPriceTag = ` ${data?.label?.local} ${data?.label?.value}%`;
                  }
                }
                let _effectiveInterestValue = 0;
                if (_effectiveInterest.length > 0) {
                  _effectiveInterestValue = _effectiveInterest[0].value;
                  setEffectiveInterest(_effectiveInterest[0].value);
                }
                let currentPaymentsSchedule = currentQuote?.paymentsSchedule.summaryPayments.filter(x => x.typeInstalment === "recurrentPayment")[0];
                let _lastSummaryProps = loanSummary;
                _lastSummaryProps.fields.legal = decodeURI(currentQuote?.auto && currentQuote.auto.documentation["terms&Conditions"]);
                setLastSummaryProps(_lastSummaryProps);
                setMonthlyPrice(currentPaymentsSchedule && currentPaymentsSchedule.payment);
                setLoanFeatures(_loanFeatures);
                setSummaryFeatures(_loanFeatures);
                changeValueCallback(currentPaymentsSchedule && currentPaymentsSchedule.payment, _effectiveInterestValue, _summaryPriceTag);
              }
            }
            setLoanErrorMessage(null);
          } else if (res && res.status === 400) {
            let currentQuote = res.data.quotes ? res.data.quotes[0] : null;
            setLoanErrorMessage(currentQuote?.errors[0].businessMessage || currentQuote?.errors[0].message);
            setSECCI(null);
            setCurrentSimulationId(null);
            setEffectiveInterest(null);
            setMonthlyPrice(null);
            setLoanFeatures([]);
            setSummaryFeatures([]);
          }
        })
        .finally(() => {
          setLoanLoading(false);
        });
    }
  };
  const setOptionValues = () => {
    let _slider = [];
    let currentvalidations = {};
    currentvalidations = currentProduct.validations.filter(x => x.period === currentPeriod)[0];
    loanProducts.length > 0 &&
      _slider.push({
        title: labels.loanProductLabel,
        options: loanProducts.map(item => {
          return {
            value: item.productTypeDesc
          };
        }),
        selected: {
          value: currentProduct.productTypeDesc,
          dataLayerValue: currentProduct.loanType
        },
        onChange: (value, val) => loanProductChange(value, val)
      });

    _slider.push({
      title: labels.durationLabel,
      options: currentProduct.validations.map(item => ({
        price: item.period,
        value: item.period
      })),
      selected: {
        value: currentPeriod,
        price: currentPeriod,
        dataLayerValue: currentPeriod
      },
      onChange: (value, val) => preiodChange(value, val)
    });
    currentvalidations?.maxDownPayment &&
      _slider.push({
        max: currentvalidations.maxDownPayment,
        min: currentvalidations.minDownPayment,
        step: 100,
        title: labels.downpaymentLabel,
        isLoan: currentTab.id === financingTab.LOAN,
        lang,
        value: {
          price: currentDownPayment,
          value: `${currentDownPayment}`
        },
        onChange: (value, val) => downPaymentChange(value, val)
      });
    currentvalidations?.maxFinalPayment &&
      _slider.push({
        max: currentvalidations.maxFinalPayment,
        min: currentvalidations.minFinalPayment,
        step: 100,
        title: labels.finalpaymentLabel,
        isLoan: currentTab.id === financingTab.LOAN,
        lang,
        value: {
          price: currentFinalPayment,
          value: `${currentFinalPayment}`
        },

        onChange: (value, val) => finalPaymentChange(value, val)
      });

    setSliders(_slider);
    setDownPayment(currentDownPayment);
    setFinalPayment(currentFinalPayment);
    setRate(currentRate);
    setPeriod(currentPeriod);
    setLoanProduct(currentProduct.loanType);
    setLoanProduct(currentProduct);
    setLoanProductList(loanProducts);
    setSummaryValues();
  };
  const getLoanProducts = () => {
    setLoanProductLoading(true);
    api.calculation
      .getProducts({
        type: "LOAN",
        countryCode: country,
        productId: vehicleProps.engine,
        productPrice: vehicleProps.retailPrice
      })
      .then(res => {
        if (res.status === 200 && res.data?.products) {
          res.data.products.forEach(product => {
            loanProducts.push({
              productId: product.productId,
              productDesc: product.productDesc,
              productTypeDesc: product.productTypeDesc,
              validations: product.validations,
              defaultSimulation: product.defaultSimulation,
              loanType: product.loanType
            });
          });
          currentProduct = loanProducts[0];
          currentDownPayment = (currentProduct.defaultSimulation.downPayment * vehicleProps.retailPrice) / 100;
          defaultDownPayment = currentDownPayment;
          currentPeriod = currentProduct.defaultSimulation.period;
          currentFinalPayment = (currentProduct.defaultSimulation.finalPayment * vehicleProps.retailPrice) / 100;
          defaultFinalPayment = currentFinalPayment;
          currentRate = currentProduct.defaultSimulation.rate;
          setOptionValues();
        }
      })
      .finally(() => {
        setLoanProductLoading(false);
      });
  };
  const loanProductChange = (item, val) => {
    currentProduct = loanProducts.filter(x => x.productDesc === item.value)[0];
    currentDownPayment = (currentProduct.defaultSimulation.downPayment * vehicleProps.retailPrice) / 100;
    currentPeriod = currentProduct.defaultSimulation.period;
    currentFinalPayment = (currentProduct.defaultSimulation.finalPayment * vehicleProps.retailPrice) / 100;
    currentRate = currentProduct.defaultSimulation.rate;
    setOptionValues();
    /** Measurement */
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "buyCarRefineLoanProduct",
      eventCategory: "buy a car refine loan",
      eventAction: "loan product",
      eventLabel: currentProduct?.productDesc
    });
  };
  const preiodChange = (item, val) => {
    currentPeriod = Number(item.value);
    setOptionValues();
    /** Measurement */
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "buyCarRefineLoanDuration",
      eventCategory: "buy a car refine loan",
      eventAction: "duration",
      eventLabel: currentPeriod
    });
  };
  const downPaymentChange = (value, val) => {
    currentDownPayment = value;
    let currentvalidations = currentProduct.validations.filter(x => x.period === currentPeriod)[0];
    if (!currentvalidations?.maxFinalPayment) {
      if (Number(currentDownPayment) !== defaultDownPayment) {
        currentFinalPayment = 0;
      } else {
        currentFinalPayment = defaultFinalPayment;
      }
    }
    setOptionValues();
    /** Measurement */
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "buyCarRefineLoanDownPayment",
      eventCategory: "buy a car refine loan",
      eventAction: "down payment",
      eventLabel: currentDownPayment
    });
  };
  const finalPaymentChange = (value, val) => {
    currentFinalPayment = value;
    setOptionValues();
    /** Measurement */
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "buyCarRefineLoanFinalPayment",
      eventCategory: "buy a car refine loan",
      eventAction: "final payment",
      eventLabel: currentFinalPayment
    });
  };
  let isDisabled = false;
  if (currentTab.id === financingTab.LOAN) {
    isDisabled = !currentSimulationId;
  }

  return (
    <>
      <div className="pdp-refine-plan grid">
        <div className="heading">
          <div className="heading-container">
            <Heading {...heading} typographyClass={"type-h3"} />
          </div>
          {tabs && <RangeOptionSelect {...tabs} onClick={option => tabClick(option)} />}
        </div>
        {loanProductLoading && <LoadingSpinner />}
        {!loanProductLoading && (
          <>
            {!tabs || (currentTab && currentTab.id === financingTab.LOAN) ? (
              <div className="loan">
                <div className="option-grid">
                  {plan &&
                    plan.length > 0 &&
                    sliders &&
                    sliders.map((slider, index) => {
                      return (
                        <>
                          {index === 0 ? (
                            <div className="info-holder">
                              <div className="loan-type">
                                <Slider
                                  key={index}
                                  {...{
                                    ...slider
                                  }}
                                />
                              </div>
                              {info && (
                                <div className={"info-button"} onClick={openInfoModal}>
                                  <InfoIcon />
                                </div>
                              )}
                            </div>
                          ) : (
                            <>
                              <Slider
                                key={index}
                                {...{
                                  ...slider
                                }}
                              />
                            </>
                          )}
                        </>
                      );
                    })}
                </div>
              </div>
            ) : (
              <CashOptions {...cashOptions} onChange={(index, value, val) => updatePlan(1, index, value, val)} />
            )}
            <div className="button-container">
              {loanErrorMessage && currentTab.id === financingTab.LOAN && <span className="warning-message">{loanErrorMessage}</span>}
              {currentTab.id === financingTab.LOAN && <BodyText html={disclaimerText} className="disclaimer" />}

              <PrimaryButton
                {...{
                  ...checkoutButton,
                  isDisabled: isDisabled || loanProductLoading || loanLoading,
                  link: { value: { ...checkoutButton?.link?.value, href: null, linktype: null } }
                }}
                callback={() => {
                  onCheckout(plan, currentTab, "submit", checkoutButton?.link?.value, {
                    downPayment: downPayment,
                    period: period,
                    simulationId: currentSimulationId,
                    SECCI: SECCI,
                    finalPayment: finalPayment,
                    rate: rate,
                    monthlyPrice: monthlyPrice,
                    effectiveInterest: effectiveInterest,
                    type: currentTab.id,
                    loanTermsAndConditions: lastSummaryProps.fields.legal
                  });
                }}
              />
            </div>
          </>
        )}
        <InfoModal {...info} showModal={showInfoModal} setShowModal={setShowInfoModal} />
      </div>
      <PdpSummary {...{ ...lastSummaryProps, features: summaryFeatures, summarySections: orderSummarySections, loanLoading: loanLoading, financingPlan: currentTab.id }} />
    </>
  );
};

Pdpfinancing.propTypes = {
  heading: PropTypes.object,
  tabs: PropTypes.object,
  sliders: PropTypes.array,
  onOptionSelected: PropTypes.func,
  loanDisclaimer: PropTypes.object,
  cashOptions: PropTypes.shape({
    checkboxes: PropTypes.array,
    description: PropTypes.object,
    disclaimer: PropTypes.object,
    onChange: PropTypes.func
  }),
  checkoutButton: PropTypes.object,
  onCheckout: PropTypes.func
};

export default Pdpfinancing;
